import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'enum',
    standalone: true
})
export class EnumPipe implements PipeTransform {
  constructor() { }
  transform(value, enumType: any): string {
    return enumType[value] || 'Unknown';
  }
}
